module.exports = __webpack_public_path__ + "static/img/ikonaPython-OFF.925d045b.png";